var _rect, _rect2, _rect3, _path, _path2, _circle, _circle2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 152,
    viewBox: "0 0 123 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.3301,
    y: 28.0972,
    width: 20,
    height: 4,
    rx: 2,
    transform: "rotate(-135.162 26.3301 28.0972)",
    fill: "white",
    fillOpacity: 0.05
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.06116,
    y: 30.5693,
    width: 15,
    height: 4,
    rx: 2,
    transform: "rotate(-4.72994 8.06116 30.5693)",
    fill: "white",
    fillOpacity: 0.05
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33.4745,
    y: 7.36816,
    width: 15,
    height: 4,
    rx: 2,
    transform: "rotate(86.5404 33.4745 7.36816)",
    fill: "white",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.375 62.4062V30H36.7188C33.5496 30 31 32.5496 31 35.7188V146.281C31 149.45 33.5496 152 36.7188 152H116.781C119.95 152 122.5 149.45 122.5 146.281V68.125H90.0938C86.9484 68.125 84.375 65.5516 84.375 62.4062ZM122.5 59.0465V60.5H92V30H93.4535C94.9785 30 96.432 30.5957 97.5043 31.668L120.832 55.0195C121.904 56.0918 122.5 57.5453 122.5 59.0465Z",
    fill: "#191919"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.312 55.5389L120.312 55.5392C121.246 56.4729 121.765 57.7392 121.765 59.0465V59.7651H92.7349V30.7349H93.4535C94.7863 30.7349 96.0521 31.2551 96.9846 32.1876L120.312 55.5389ZM83.6401 30.7349V62.4062C83.6401 65.9575 86.5425 68.8599 90.0938 68.8599H121.765V146.281C121.765 149.044 119.544 151.265 116.781 151.265H36.7188C33.9555 151.265 31.7349 149.044 31.7349 146.281V35.7188C31.7349 32.9555 33.9555 30.7349 36.7188 30.7349H83.6401Z",
    stroke: "white",
    strokeOpacity: 0.02,
    strokeWidth: 1.46988
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59.5011,
    cy: 96.3097,
    r: 5.30965,
    fill: "#242424"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.9989,
    cy: 96.3097,
    r: 5.30965,
    fill: "#242424"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6685 115.637C91.9831 109.951 84.2721 106.757 76.2317 106.757C68.1913 106.757 61.5196 108.912 55.8342 114.597",
    stroke: "#242424",
    strokeWidth: 1.46988
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSearch);
export default __webpack_public_path__ + "static/media/no-search.8765060c.svg";
export { ForwardRef as ReactComponent };